import React from 'react';
import { arrowUpSvg } from '../../utils';
import { shortenString } from '../../../../components/ListingCard/utils';
import css from './BigCard.module.css';
import { useIntl } from 'react-intl';

const BigCard = ({ blog, setFocusedBlog, history }) => {
  const intl = useIntl();
  const blogLink = blog.link;
  return (
    <div className={css.wrapper}>
      <div
        className={css.sectionTop}
        style={{ backgroundImage: `url(${blog.preview.image})` }}
      ></div>
      <div className={css.sectionBottom}>
        <p className={css.title}>{blog.preview.title}</p>
        <p className={css.description}>{shortenString(blog.preview.text, 200)}</p>
        <p
          className={css.readPost}
          onClick={blogLink ? () => history.push(blogLink) : setFocusedBlog}
        >
          {intl.formatMessage({ id: 'CustomBlogPage.BigCard.readPost' })} {arrowUpSvg}
        </p>
      </div>
    </div>
  );
};

export default BigCard;
